import type { Theme } from '@aws-amplify/ui-react';
import buildAmplifyTheme from './buildAmplifyTheme';
import { PRESETS, resolvePreset } from './presets';
import type { PresetKey } from './presets';

export { default as useColorMode } from './useColorMode';
export type { ColorMode } from './useColorMode';
export { default as useReducedMotion } from './useReducedMotion';
export type { ColorTokens, ModeTokens } from './tokens';
export { fontFamily, fontSize, fontWeight, radius, space, duration, ease } from './tokens';
export type { PresetKey } from './presets';
export { PRESETS } from './presets';

export const activePresetKey: PresetKey = resolvePreset(import.meta.env.VITE_THEME_PRESET);
export const activeTheme: Theme = buildAmplifyTheme(PRESETS[activePresetKey]);
